module.exports = __webpack_public_path__ + "img/about-6.77c6ed98.jpg";